export async function fileImageDimension(
  fileImage: File
): Promise<{ width: number; height: number }> {
  return new Promise<{ width: number; height: number }>((resolve, reject) => {
    const reader = new FileReader();

    reader.readAsDataURL(fileImage);
    reader.onload = function (event: ProgressEvent<FileReader>) {
      if (!event.target) {
        return;
      }

      const image = new Image();

      image.src = event.target.result as string;

      image.onload = () => {
        return resolve({ width: image.width, height: image.height });
      };

      image.onerror = (error) => {
        return reject(error);
      };
    };
  });
}
